/**
 * Sexo da pessoa (pedido do responsável, 02/11/2026): duas opções, gravadas em `pessoas.sexo`
 * (migration 0113). Vazio (`null`) = não informado. Visitante também é uma linha de `pessoas`.
 */
export type Sexo = "masculino" | "feminino";

export const OPCOES_SEXO: ReadonlyArray<{ chave: Sexo; rotulo: string }> = [
  { chave: "masculino", rotulo: "Masculino" },
  { chave: "feminino", rotulo: "Feminino" },
];

/** Aceita só os dois valores válidos; qualquer outra coisa vira "" (não informado). */
export function soSexo(valor: unknown): Sexo | "" {
  return valor === "masculino" || valor === "feminino" ? valor : "";
}

/** Texto para exibir; `null` quando não informado (a tela decide o que mostrar no lugar). */
export function rotuloSexo(valor: string | null | undefined): string | null {
  const achado = OPCOES_SEXO.find((o) => o.chave === valor);
  return achado ? achado.rotulo : null;
}
